import React from 'react';
import { PatternFormatProps, PatternFormat } from 'react-number-format';

import { Input } from '@eika/input';

const AccountNumberInput: React.FC<Omit<PatternFormatProps, 'format'>> = (props) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <PatternFormat customInput={Input} format="#### ## #####" type="text" {...props} />
);

export default AccountNumberInput;
